import { render, staticRenderFns } from "./BusDataSyncUopDocDetailSetModal.vue?vue&type=template&id=3ab0b22d&"
import script from "./BusDataSyncUopDocDetailSetModal.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncUopDocDetailSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports